// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"597":"projects","884":"admin"}[chunkId] + "." + {"597":"256f8a10","884":"92ef795b"}[chunkId] + ".js";
};